import cx from 'classnames';
import React, { PropTypes } from 'react';
import { push } from 'react-router-redux';

export default function JobRequestLinks(props) {


  const links = [
    {key: 'position', name: 'Position Info', route: props.jobId ? `/client/jobrequest/${props.jobId}` : '/client/jobrequest' },
    {key: 'description', name: 'Job Description', route: `/client/jobrequest/${props.jobId||0}/description` },
    {key: 'adddocuments', name: 'Add Documents', route: `/client/jobrequest/${props.jobId||0}/adddocuments` },
    {key: 'skills', name: 'Skills', route: `/client/jobrequest/${props.jobId||0}/skills` },
    {key: 'summary', name: 'Summary of Skills', route: `/client/jobrequest/${props.jobId||0}/skills/summary` },
    {key: 'workschedule', name: 'Work Schedule', route: `/client/jobrequest/${props.jobId ||0}/workschedule` },
    {key: 'addcontact', name: 'Reporting', route: `/client/jobrequest/${props.jobId ||0}/addcontact` },
    {key: 'authorize', name: 'Authorize', route: `/client/jobrequest/${props.jobId||0}/authorize` },


  ];

  const navigateTo = (link) =>
    (event) => {
      props.dispatch(push(link.route));
    }

  return (
    <ul className='job-request-links'>
      {
        links.map((link, index) =>
          <li
            key={link.name}
            data-id={link.name}
            className={cx({ active : (link.name === props.activeLink) })}
            onClick={navigateTo(link)}
            >
            <div className='job-request-checkmark'>{(props.completed||{})[link.key] ? '✔ ' : ''}</div>
            <div className='label'>{link.name}</div>
          </li>
        )
      }
    </ul>
  );
}

JobRequestLinks.propTypes = {
  activeLink : PropTypes.string,
  jobId : PropTypes.integer,
  completed: PropTypes.object
}



// WEBPACK FOOTER //
// ./shared/react/client/SubNavigation/JobRequestLinks/index.js